module.exports = __webpack_public_path__ + "img/Kalkofen.bea74268.jpg";